import React, { useState, useEffect, useRef } from 'react'

const INITIAL_STATE ={
    active: false
}

function SidePanelToggle(props){
    const [state,setState] = useState(INITIAL_STATE)
    const wrapperRef = useRef(null);
    const { active } = state

    let style ={}

    if(props.overrideStyle && active){
        style = {...props.overrideStyle}
    } else {
        if(active){
            style.width = "80%"
        }
    }

    useEffect(() => {
        if(props.autoCloseOnBlur) {
            function handleClickOutside(event) {
                if (wrapperRef.current && !wrapperRef.current.contains(event.target) && active) {
                    setState(prevState => ({
                        ...prevState,
                        active: false
                    }))
                    if(props.onBlur){
                        props.onBlur()
                    } else {
                        props.onClick()
                    }
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }
    }, [props.autoCloseOnBlur, wrapperRef, active]);

    useEffect(() => {
        if(props.overrideActiveState !== null){
            setState(prevState => ({
                ...prevState,
                active: props.overrideActiveState
            }))
        }
    }, [props.overrideActiveState])

    // useEffect(() => {
    //     if(state.active){
    //         angular.element("body").css("overflow-y", "hidden")
    //     } else {
    //         angular.element("body").css("overflow-y", "auto")
    //     }
    // }, [state.active])

    return <div id={props?.id ?? `sdbr-${parseInt(Math.random()*1000)+1}`} ref={wrapperRef} className={`theme-panel theme-panel-lg ${props.align === "left" ? "left" : ""} ${active ? "active": ""} ${props.className}`} style={style}>
        <div className="theme-panel-content">
            {!props.showIconOnActive || (props.showIconOnActive && active) && <a href="javascript:;" onClick={() => {
                setState(prevState => ({
                    ...prevState,
                    active: !active
                }))
                props.onClick()
        }} className="pull-right text-black">
                <i className={"fa fa-2x "+(props.icon)}></i>
            </a>}
            <div className="clearfix"></div>
            {props.children}
        </div>
    </div>
}

SidePanelToggle.defaultProps = {
    showIconOnActive: false,
    align: "right",
    onClick: () => {},
    onBlur: false,
    autoCloseOnBlur: false,
    overrideActiveState: null,
    overrideStyle: false,
    className: "",
    icon: "fa-times"
}

export default SidePanelToggle